import { Button } from "@mui/material";
import React from "react";
import { isNullOrUndefined } from "../../utils/utils";

export default function PrimaryButton({
  size,
  name,
  height,
  width,
  textColor,
  borderRadius,
  border,
  borderColor,
  backgroundColor,
  hoverBackground,
  handleOnClick,
  handleTouchStart,
  type,
  isDisabled,
  loading,
}) {
  return (
    <Button
      variant="contained"
      size={size}
      disabled={isDisabled || loading ? true : false}
      sx={{
        height: height,
        width: isNullOrUndefined(width) ? "100%" : width,
        color: textColor,
        border: border,
        borderColor: borderColor,
        borderRadius: borderRadius,
        textTransform: "none",
        backgroundColor: isNullOrUndefined(backgroundColor)
          ? "#2795BF"
          : backgroundColor,
        fontFamily: "inherit",
        boxShadow: "none",
        ":hover": {
          backgroundColor: isNullOrUndefined(hoverBackground)
            ? "#4974A5"
            : hoverBackground,
          color: "#ffff",
          boxShadow: "none",
        },
        // "&:disabled": {
        //   backgroundColor: "#2795BF",
        //   color: "#ffff",
        // },
      }}
      onClick={handleOnClick}
      onTouchStart={handleTouchStart}
      type={type}
    >
      {loading ? <div className="loader"></div> : name}
      {/* {name} */}
    </Button>
  );
}
